import { render } from "./passwordless-login-link.vue?vue&type=template&id=3b745efb"
import script from "./passwordless-login-link.vue?vue&type=script&lang=js"
export * from "./passwordless-login-link.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__